var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.406,
    height: 6.422,
    viewBox: "0 0 9.406 6.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#040405;stroke:#040405;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.703 0.711)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1773.271,413.352l3.06-3.09,3.06,3.09.94-.951-4-4.049-4,4.049Z",
    transform: "translate(-1772.331 -408.352)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowUp);
export default __webpack_public_path__ + "static/media/ico-arrow-up.786d3a08fe7149ab9bbc5c8c8cdc5910.svg";
export { ForwardRef as ReactComponent };